/**
 * フィルタ
 *
 * mustache記法で使用するフィルタをVueに登録する
 */

import Vue from 'vue'
import moment from 'moment'

/**
 * 日付のフォーマット
 *
 * @param value
 * @return {string}
 */
Vue.filter('formatDate', (value) => {
  return moment(String(value)).format('MM月 DD日')
})

Vue.filter('formatMonthDay', (value) => {
  if (value) {
    return moment(String(value)).format('MM/DD')
  } else {
    return 'ー'
  }
})

/**
 * Month format
 *
 * @param value
 * @return {string}
 */
Vue.filter('formatMonth', (value) => {
  return moment(String(value)).format('YYYY年 MM月')
})

/**
 * Month format
 *
 * @param value
 * @return {string}
 */
Vue.filter('formatMonthRange', (year, month, range) => {
  let time = moment({ year: year, month: month - 1 }).add(range, 'months')

  return {
    month: time.month() + 1,
    year: time.year(),
    time: time.format('YYYY年 MM月')
  }
})

/**
 * 日付と時刻のフォーマット
 *
 * @param value
 * @return {string}
 */
Vue.filter('formatDatetime', (value) => {
  return moment(String(value)).format('YYYY年 MM月 DD日 HH:mm')
})

/**
 * 日付と時刻のフォーマット
 *
 * @param value
 * @return {string}
 */
Vue.filter('formatDatetime1', (value) => {
  return moment(String(value)).format('YYYY年 MM月 DD日')
})

/**
 * Return last day of the month
 *
 * @param value
 * @return {string}
 */
Vue.filter('convertLastDayOfMonth', (value) => {
  return moment(String(value)).format('YYYY年 M月末日')
})

/**
 * 日付のフォーマット
 *
 * @param value
 * @return {string}
 */
Vue.filter('japaneseDatetime', (value) => {
  return moment(String(value)).format('MM月DD日')
})

/**
 * number format
 *
 * @param value
 * @return {string}
 */
Vue.filter('formatNumber', (value) => {
  return value.toString().replace(/(.)(?=(.{3})+$)/g, '$1,').replace('.,', '.').replace(',.', '.')
})

/**
 * 日付と時刻のフォーマット
 *
 * @param value
 * @return {string}
 */
Vue.filter('removeHtmlTag', (value) => {
  var s = ''

  if (value !== null) {
    // styleタグは中身の定義も含めて削除
    let str = value.replace(/<style[^>]+?\/>|<style(.|\s)*?\/style>/gi, '')
    // htmlタグを削除
    s = str.replace(/<("[^"]*"|'[^']*'|[^'">])*>/g, '')
  }

  return s
})

/**
 * add 人 sign in front of the number
 *
 * @param value
 * @return {string}
 */
Vue.filter('people', function (value) {
  return `${value}人`
})

/**
 * How can I convert a string to boolean
 *
 * @param string
 * @return {Boolean}
 */
Vue.filter('stringToBoolean', function (string = '') {
  switch (string.toLowerCase().trim()) {
    case 'true':
    case 'yes':
    case '1':
      return true
    // case "false": case "no": case "0": case null: return false;
    default:
      return false
  }
})

Vue.filter('dateRangeText', function (period) {
  if (typeof period !== 'undefined' && period) {
    if (moment(String(period[1])) < moment(String(period[0]))) {
      period = [moment(String(period[1])).format('YYYY/MM/DD'), moment(String(period[0])).format('YYYY/MM/DD')]
      return period.join(' ~ ')
    } else {
      if (moment(String(period[0])) < moment(String(period[1]))) {
        period = [moment(String(period[0])).format('YYYY/MM/DD'), moment(String(period[1])).format('YYYY/MM/DD')]
        return period.join(' ~ ')
      } else {
        if (period[0]) {
          return moment(String(period[0])).isValid() ? moment(String(period[0])).format('YYYY/MM/DD') : period[0]
        }
      }
    }
  }
})

Vue.filter('formatDateShot', (value) => {
  return value ? moment(String(value)).format('YY/MM/DD') : ''
})
Vue.filter('formatDate', (value) => {
  return moment(String(value)).format('YYYY-MM-DD')
})
Vue.filter('toSlashDate', (value) => {
  return value ? value.replace(/-/g, '/') : ''
})

Vue.filter('formatCustomInteger', (value) => {
  if (value) {
    value = value.toString().replace(/[^0-9.-]/g, '')
    let total = parseFloat(value).toFixed(3).toString()
    let numberArray = total.split('.')
    let prefix = ''
    if (parseInt(numberArray[0]) < 0) {
      prefix = '-'
    }
    if (numberArray[1] && parseInt(numberArray[1]) > 500) {
      return prefix + Math.abs(parseInt(numberArray[0]) + 1).toString().replace(/(.)(?=(.{3})+$)/g, '$1,').replace('.,', '.').replace(',.', '.')
    }
    return prefix + Math.abs(parseInt(numberArray[0])).toString().replace(/(.)(?=(.{3})+$)/g, '$1,').replace('.,', '.').replace(',.', '.')
  }
  return 0
})

/**
 * 数値を小数第2位で四捨五入する。
 *
 * @param value
 * @return {string}
 */
Vue.filter('formatPercent', value => Math.round(value * 10) / 10)

/**
 * 数値を小数第2位で四捨五入する。
 * InfinityやNaNの場合は0を表示
 * @param value
 * @return {string}
 */
Vue.filter('formatPercent2', (value) => {
  if (value === Infinity || isNaN(value)) {
    return '0%'
  } else {
    const roundedValue = (Math.round(value * 100) / 100).toFixed(2)
    return `${roundedValue * 100}%`
  }
})

Vue.filter('formatYen', (value) => {
  if (value) {
    return `￥${value}`
  } else {
    return 'ー'
  }
})

Vue.filter('formatCheckbox', (value) => {
  if (value) {
    return '✓'
  } else {
    return ''
  }
})

Vue.filter('formatTime', (value) => {
  if (value) {
    const timeArray = value.split(':')
    if (timeArray[0] >= 12) {
      return timeArray[0] - 12 >= 10 ? `${timeArray[0] - 12}:${timeArray[1]} PM` : `0${timeArray[0] - 12}:${timeArray[1]} PM`
    } else {
      return `${value} AM`
    }
  } else {
    return 'ー'
  }
})

Vue.filter('formatList', (value) => {
  if (value) {
    return value.split(',')
  } else {
    return 'ー'
  }
})



// WEBPACK FOOTER //
// ./src/utils/filters.js